import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import main from "./PptImages/main_2.jpg";
export default function DigitalImageModal() {
	const [show, setShow] = useState(false);
	const [modalShow, setModalShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	return (
		<>
			<img
				onClick={() => setModalShow(true)}
				className="image-preview"
				src={main}
				width="40%"
			/>
			<Modal
				show={modalShow}
				onHide={() => setModalShow(false)}
				size="lg"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Body>
					<img src={main} alt="main_1" width="100%" />
				</Modal.Body>
			</Modal>
		</>
	);
}
